import { jsx as _jsx } from "react/jsx-runtime";
import { useRef, useEffect, useMemo, createContext, useContext } from 'react';
import { useSafeTrackerProvider } from './hooks';
const EMPTY = {
    trackPageView() {
    },
    trackEvent() {
    },
};
const Context = createContext(EMPTY);
Context.displayName = 'TrackerContext';
export const Provider = Context.Provider;
export const useTrackPageView = () => {
    const context = useContext(Context);
    return context.trackPageView;
};
export const useTrackEvent = () => {
    const context = useContext(Context);
    return context.trackEvent;
};
const Tracker = ({ collect, provider, children }) => {
    const safeProvider = useSafeTrackerProvider(provider);
    const currentLocation = useRef(null);
    const trackerContext = useMemo(() => {
        return {
            trackPageView(location, match) {
                const path = match.path;
                const referrer = currentLocation.current;
                currentLocation.current = { ...location, path };
                const data = {
                    referrer,
                    location: currentLocation.current,
                    ...collect('pageView', currentLocation.current),
                };
                safeProvider.trackPageView(data);
            },
            trackEvent(event) {
                const data = {
                    ...collect('event'),
                    ...event,
                };
                safeProvider.trackEvent(data);
            },
        };
    }, [safeProvider, collect]);
    useEffect(() => {
        safeProvider.install();
        return () => safeProvider.uninstall();
    }, [safeProvider]);
    return _jsx(Provider, Object.assign({ value: trackerContext }, { children: children }), void 0);
};
export default Tracker;
